<template>
  <div class="footer">
    <div class="content">
      <Resource
        :src="
          !isChinese()
            ? transformImage(getFeUrl('/rendora/logo.png'))
            : defaultLogo
        "
        class="w-[130px] h-[46px] transform cursor-pointer object-contain"
        alt="logo"
        @click="goLink"
      />
      <div class="flex justify-between mt-[26px]">
        <div class="w-[690px]">
          <div class="text-white text-14 !font-semibold">
            The name "Rendora" derives from the term “render,” which is
            fundamental in 3D graphics for generating the final visual output
            from a 3D model. This concept is central to Rendora's
            mission—delivering high-quality, visually captivating 3D content for
            everyone.
            <div class="mt-[14px]">Support: contact@rendora.ai</div>
            <div class="mt-[5px]">Follow us</div>
          </div>
          <div class="flex gap-[20px] mt-[30px]">
            <a
              v-for="item in iconList"
              :key="item.name"
              class="cursor-pointer"
              :href="item.url"
              target="_blank"
            >
              <iconpark-icon
                :name="item.name"
                size="30"
                class="text-white hover:text-primary"
              ></iconpark-icon>
            </a>
          </div>
        </div>
        <div class="flex flex-col gap-[35px]">
          <div v-for="item in linkList" :key="item.name">
            <nuxt-link
              class="text-white cursor-pointer hover:text-primary underline font-semibold"
              :href="item.url"
              :name="item.name"
              :target="item.target"
            >
              {{ item.name }}
            </nuxt-link>
          </div>
        </div>
      </div>
      <div class="text-white opacity-40 text-14 mt-[45px]">
        <div>Company: Rendora LLC</div>
        <div>
          Address: 1209 Orange Street, Wilmington, New Castle County, Delaware
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import defaultLogo from '~/assets/svg/logo.svg?url'

const goLink = () => {
  trackEvent(TRACK_EVENT.CLICK_LOGO)
  window.location.href = window.location.origin
}

const iconList = [
  {
    name: 'icon-discord',
    url: 'https://discord.gg/xpePmZYeEp',
  },
  {
    name: 'icon-x',
    url: 'https://x.com/RendoraAI',
  },
  {
    name: 'icon-youtube',
    url: 'https://www.youtube.com/channel/UCiVeyPccijStmOlCOD_IRnw',
  },
  {
    name: 'icon-ins',
    url: 'https://www.linkedin.cn/incareer/company/rendora-ai/',
  },
]

const linkList: { target: '_self' | '_blank'; name: string; url: string }[] = [
  {
    name: 'Tutorial',
    url: 'https://www.rendora.ai/tutorial',
    target: '_self',
  },
  {
    name: 'Policy Privacy',
    url: 'https://protocol.rendora.ai/legal/privacy-policy',
    target: '_blank',
  },
  {
    name: 'User Agreement',
    url: 'https://protocol.rendora.ai/legal/user',
    target: '_blank',
  },
  {
    name: 'Software Purchase Agreement',
    url: 'https://protocol.rendora.ai/legal/software',
    target: '_blank',
  },
]
</script>

<style lang="scss" scoped>
.footer {
  background: #0a0c10;
  padding: 80px 0 40px;
  .content {
    width: 1200px;
    margin: 0 auto;
  }
}
</style>
